// Convert a string to Base64
export const toBase64 = (input: string) => {
    return Buffer.from(input).toString('base64');
};

// Convert a Base64 string back to normal text
export const fromBase64 = (input: string) => {
    return Buffer.from(input, 'base64').toString('utf-8');
};
